import { Navigate } from "react-router-dom";
type Props = {
    children: JSX.Element,
  };

const ProtectedRoute: React.FC<Props> = ({ children }) => {
    const email = localStorage.getItem('email');    
    return (
      email === 'ifahad@gmail.com' ? children : <Navigate to="/login" />
    );
}

export default ProtectedRoute;